import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class StudyRequiredGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (localStorage.getItem('study')) {
      return true;
    }

    this.router.navigate(['/home']);
    return false;
  }
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/guards/study-required.guard.ts